import { useEffect } from "react";
import { Link } from "react-router-dom";
import { publicRoute } from "routing";
import { LandingScreen } from "./landingScreen";

export const HomeScreen = () => {
  useEffect(() => {
    document.title = "Simulateur assurance climatique | Crédit Agricole";
  }, []);

  return (
    <div className="flex flex-col items-center justify-between">
      <LandingScreen />

      <Link
        to={publicRoute.accessibility}
        className="mt-8 px-4 text-center text-xs font-openSansBold text-blue-800 underline hover:text-primary-600"
      >
        Accessibilité : partiellement conforme
      </Link>
    </div>
  );
};
